var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeAddPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#F6F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8334 19.9827C35.3684 20.5883 35.6413 20.7426 36.4929 20.7426H40C41.6569 20.7426 43 22.0857 43 23.7426V36C43 37.6569 41.6569 39 40 39H19C17.3431 39 16 37.6569 16 36V23.7426C16 22.0857 17.3431 20.7426 19 20.7426H22.4416C23.2932 20.7426 23.577 20.5764 24.1011 19.9827L24.9636 18.9736C25.5313 18.3206 26.11 18 27.2236 18H31.7109C32.8245 18 33.4032 18.3206 33.9709 18.9736L34.8334 19.9827Z",
    stroke: "#525D71",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4961,
    cy: 29.5547,
    r: 4.5,
    stroke: "#525D71",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3461,
    cy: 25.35,
    r: 1.35,
    fill: "#525D71"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 39,
    r: 8,
    fill: "#F6F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 39L43.4579 39L45.2865 39L46.2008 39",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35.8L43 39.4572L43 41.2857L43 42.2",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 29,
    stroke: "#DFE2EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeAddPhoto);
export default __webpack_public_path__ + "static/media/ic-large-add-photo.8b60de7771ca5d72c00e7c312a961fa6.svg";
export { ForwardRef as ReactComponent };